"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockFile = void 0;
var createMockFile = function (_a) {
    var body = _a.body, mimeType = _a.mimeType, name = _a.name, lastModifiedDate = _a.lastModifiedDate;
    var blob = new Blob([body], { type: mimeType });
    blob.lastModifiedDate = lastModifiedDate || new Date();
    blob.name = name;
    return blob;
};
exports.createMockFile = createMockFile;
